import f from "./funcs";
import $ from "jquery";
import _ from "underscore";
import Marionette from "marionette";
import langDictionary from "./classes/lang/init";
import System from "./classes/system/System";

window.f = f;

f.lang = langDictionary.get.bind(langDictionary);

Marionette.TemplateCache.prototype.compileTemplate = function(template) {
    return _.template(template);
};

Marionette.TemplateCache.prototype.loadTemplate = function(templateOrSelector) {
    let template;

    try {
        let templateEl = document.querySelector(templateOrSelector);
        template = templateEl.innerHTML;
    } catch (err) {
        //
    }

    if ( !template ) {
        template = templateOrSelector;
    }

    return template;
};

let Behaviors = {};
window.Behaviors = Behaviors;

let extend = Marionette.Behavior.extend;
Marionette.Behavior.extend = function() {
    let Child = extend.apply(this, arguments);
    Behaviors[ Child.className ] = Child;
    return Child;
};

Marionette.Behaviors.behaviorsLookup = function() {
    return Behaviors;
};

Marionette.ItemView.prototype.attachElContent = function(html) {
    this.el.innerHTML = html;
    return this;
};

$(window).on("popstate", function() {
    // не запирваемся с роутингом (всего 2 url: "/login", "/")
    location.reload();
});

window.system = new System({
    onReady() {
        $("body").removeClass("loading");
    }
});